// Consent-safe Meta Pixel wrapper (spec §4.3). No-ops unless the Pixel was
// loaded by plugins/cookie-consent.client.ts and consent has not been revoked.
import { META_PIXEL_ID } from '~/utils/tracking/metaEvents';

type Fbq = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: Fbq;
    __w369MetaRevoked?: boolean;
  }
}

export const useMetaPixel = () => {
  const ready = () => import.meta.client && typeof window.fbq === 'function' && !window.__w369MetaRevoked;

  const track = (event: string, params: Record<string, unknown> = {}, eventId?: string): boolean => {
    if (!ready()) return false;
    if (eventId) window.fbq?.('track', event, params, { eventID: eventId });
    else window.fbq?.('track', event, params);
    return true;
  };

  const trackCustom = (event: string, params: Record<string, unknown> = {}): boolean => {
    if (!ready()) return false;
    window.fbq?.('trackCustom', event, params);
    return true;
  };

  // fbevents drops a second `track('PageView')` for the same pixel; `trackSingle` is not
  // deduplicated, so SPA navigations use it.
  const pageView = (): boolean => {
    if (!ready()) return false;
    window.fbq?.('trackSingle', META_PIXEL_ID, 'PageView');
    return true;
  };

  return { ready, track, trackCustom, pageView };
};
